// extracted by mini-css-extract-plugin
export default {"table":"Cart_table__6mRZS","icons":"Cart_icons__9NPOd","summary":"Cart_summary__t1lpJ","card":"Cart_card__54SVW","text":"Cart_text__96J4E","count":"Cart_count__D920U"};